import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';
import { fetchData } from '../utils/prismicUtils';
import Loading from '../common/Loading';
import Error from '../common/Error';
import Feature from './Feature';
import PortfolioList from './PortfolioList';
import Layout from '../common/Layout';
import './Portfolio.css';

export default function Portfolio() {
  const [ctx, setCtx] = useState({ data: null, loading: true, error: null });
  const [filter, setFilter] = useState(null);
  const location = useLocation();
  const documentFilter = location.pathname.slice(11);

  useEffect(() => {
    fetchData(setCtx, 'document.type', 'portfolio_item');
    setFilter('feature');
    if (location.pathname !== '/portfolio') {
      setFilter(documentFilter);
    }
  }, [location, documentFilter]);

  const portfolioNav = (
    <div className="portfolio-filter">
      <a
        className={clsx(
          'filter-button',
          location.pathname === '/portfolio/health-and-science' && 'active',
        )}
        href="/portfolio/health-and-science"
      >
        health + science
      </a>
      <a
        className={clsx(
          'filter-button',
          location.pathname === '/portfolio/art-and-design' && 'active',
        )}
        href="/portfolio/art-and-design"
      >
        art + design
      </a>
      <a
        className={clsx(
          'filter-button',
          location.pathname === '/portfolio/media-and-society' && 'active',
        )}
        href="/portfolio/media-and-society"
      >
        media + society
      </a>
    </div>
  );

  if (ctx.loading) return <Loading />;
  if (!ctx.data || !ctx.data.length || ctx.error) return <Error />;

  return (
    <Layout>
      {filter === 'feature' ? (
        <Feature portfolioNav={portfolioNav} />
      ) : (
        <PortfolioList list={documentFilter} portfolioNav={portfolioNav} />
      )}
    </Layout>
  );
}
